<template>
    <div class="flex flex-col items-center gap-4 md:gap-10 w-full max-w-4xl">
        <!-- Header -->
        <div class="text-center leading-tight">
            <h2 class="max-w-2xl display-medium text-balance mb-2 md:mb-6">
                <span class="text-ink">{{ t("onboarding.pathSelection.title") }}</span>
            </h2>
            <p class="text-ink-muted text-center text-pretty body md:display-serif max-w-2xl">
                {{ t("onboarding.pathSelection.subtitle") }}
            </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6 w-full max-w-4xl">
            <OnboardingPathCard
                :is-selected="selectedPath === 'guided'"
                icon="bi-card-list"
                :title="t('onboarding.pathSelection.guidedTitle')"
                :description="t('onboarding.pathSelection.guidedDescription')"
                :duration="t('onboarding.pathSelection.guidedDuration')"
                :label="t('onboarding.pathSelection.guidedLabel')"
                data-testid="path-guided"
                @select="selectPath('guided')" />

            <OnboardingPathCard
                :is-selected="selectedPath === 'chat'"
                icon="bi-stars"
                :title="t('onboarding.pathSelection.chatTitle')"
                :description="t('onboarding.pathSelection.chatDescription')"
                :duration="t('onboarding.pathSelection.chatDuration')"
                :label="t('onboarding.pathSelection.chatLabel')"
                @select="selectPath('chat')" />

            <OnboardingPathCard
                :is-selected="selectedPath === 'homepage'"
                icon="bi-house-fill"
                :title="t('onboarding.pathSelection.homepageTitle')"
                :description="t('onboarding.pathSelection.homepageDescription')"
                :duration="t('onboarding.pathSelection.homepageDuration')"
                :label="t('onboarding.pathSelection.homepageLabel')"
                @select="selectPath('homepage')" />
        </div>
    </div>
</template>

<script setup>
import { logUserInteraction } from "~vue/utils/logUtils";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

import OnboardingPathCard from "./OnboardingPathCard.vue";

const { t } = useI18n();

const emit = defineEmits(["pathSelected"]);

const selectedPath = ref(null);

function selectPath(path) {
    selectedPath.value = path;
    emit("pathSelected", path);
}

// Log event when path selection is displayed
onMounted(() => {
    logUserInteraction("onboarding_path_displayed");
});
</script>
